// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__r9yhO","circle":"CheckboxInput_circle__JAEf9"};